import { WelcomeKitData } from "@platform/types/dashboard.types";

export const welcomeKitData: WelcomeKitData = {
  files: [
    {
      name: "All Images",
      type: "ZIP",
      size: "200 KB",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/Pollinator-WelcomeKit-All-Images.zip",
    },
  ],
  images: [
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/post/Pollinator_Participant_Portrait_Light.jpg",
      alt: "Pollinator Participant Post - Light Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/post/Pollinator_Participant_Portrait_Light.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/post/Pollinator_Participant_Portrait_Dark.jpg",
      alt: "Pollinator Participant Post - Dark Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/post/Pollinator_Participant_Portrait_Dark.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/story/Pollinator_Participant_Story_Light.jpg",
      alt: "Pollinator Participant Story - Light Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/story/Pollinator_Participant_Story_Light.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/story/Pollinator_Participant_Story_Dark.jpg",
      alt: "Pollinator Participant Story - Dark Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/story/Pollinator_Participant_Story_Dark.jpg",
    },
  ],
  captions: [
    {
      text: "I'm participating in @pollinator_coop this October—a new program from the co-founder of @_artcoop that connects aligned peers for 5 weeks of capacity-building and focused creative momentum. Pollinator is currently only open to alumni from select institutions, including {{organization.name}}. Join me for the pilot program, and help build a stronger, more interconnected cultural ecosystem. 🐝 Head to Pollinator.coop to learn more 💻✨ #Pollinator",
    },
  ],
  links: [
    {
      title: "WK About the enrollment phase",
      icon: "FileText",
      url: "/support/enrollment-phase",
    },
    {
      title: "Invitations from organizations",
      icon: "Users",
      url: "/support/organization-invitations",
    },
    {
      title: "Why invite a friend to Pollinator?",
      icon: "HelpCircle",
      url: "/support/invite-friends",
    },
    {
      title: "See all Pollinator support articles",
      icon: "Newspaper",
      url: "/support/articles",
    },
  ],
};
